import * as React from 'react';

import { useLinkToolbarButton, useLinkToolbarButtonState } from '@platejs/link/react';
import { Link } from 'lucide-react';
import { ToolbarEditorButton } from './toolbar-editor';

export function LinkToolbarButton(props: React.ComponentProps<typeof ToolbarEditorButton>) {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);

  return (
    <ToolbarEditorButton {...props} {...buttonProps} data-plate-focus tooltip="Link">
      <Link />
    </ToolbarEditorButton>
  );
}
